import BaseServiceCrud from './BaseServiceCrud';


export default class UserAbsenceReasonService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user-absence-reason';
      //  this.getValue = this.getValue.bind(this);
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            reason: criteria.reason,            
            status: criteria.status?.enumValue,            
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            forLeave: criteria.forLeave
        });
    }
}
